export default "__VITE_ASSET__CoH2oJ8E__"